import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { usePermission } from '../../../context/PermissionContext';
import { Menu, X, Database, LayoutDashboard, FolderOpen, BarChart3, Package, ShoppingCart, ClipboardList, TrendingUp, Box, Receipt } from 'lucide-react';

const APIsSidebar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { hasPermission } = usePermission();

  const navigationItems = [
    {
      category: 'APIs',
      items: [
        { name: 'Dashboard', path: '/tiles/apis/dashboard', icon: <LayoutDashboard className="w-5 h-5" />, permission: 'apis' },
        { name: 'Snowflake Kiva API', path: '/tiles/apis/snowflake-kiva', icon: <Database className="w-5 h-5" />, permission: 'apis' },
        { name: 'Location Inventory Query', path: '/tiles/apis/location-inventory', icon: <FolderOpen className="w-5 h-5" />, permission: 'apis' },
        { name: 'Order Cycle Time Report', path: '/tiles/apis/order-cycle-time', icon: <BarChart3 className="w-5 h-5" />, permission: 'apis' },
        { name: 'Order Details Query', path: '/tiles/apis/order-details-query', icon: <Package className="w-5 h-5" />, permission: 'apis' },
        { name: 'Order Query', path: '/tiles/apis/order-query', icon: <ShoppingCart className="w-5 h-5" />, permission: 'apis' },
        { name: 'Picking Report', path: '/tiles/apis/picking-report', icon: <ClipboardList className="w-5 h-5" />, permission: 'apis' },
        { name: 'Sales Order Report', path: '/tiles/apis/sales-order-report', icon: <TrendingUp className="w-5 h-5" />, permission: 'apis' },
        { name: 'SKU Master View', path: '/tiles/apis/sku-master-view', icon: <Box className="w-5 h-5" />, permission: 'apis' },
        { name: 'View Receipt Detail', path: '/tiles/apis/view-receipt-detail', icon: <Receipt className="w-5 h-5" />, permission: 'apis' }
      ]
    }
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      <button
        className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-md bg-slate-800 text-slate-200"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {isMobileMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      <div
          className={`fixed inset-y-0 left-0 z-40 transition-transform duration-300 transform
            ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
            h-screen bg-slate-800 border-r border-slate-700 w-64 overflow-y-auto`}
      >
        <div className="p-4 border-b border-slate-700/50">
          <Link
            to="/"
            className="flex items-center px-4 py-2 text-sm text-slate-300 hover:bg-slate-700/50 hover:text-slate-100 rounded-md"
          >
            <span className="mr-3">←</span>
            <span>Back to HQ</span>
          </Link>
        </div>

        <nav className="mt-4">
          {navigationItems.map((section) => {
            // Filter items based on permissions
            const permittedItems = section.items.filter(item => hasPermission(item.permission));

            // Only render the section if it has at least one permitted item
            if (permittedItems.length === 0) return null;

            return (
              <div key={section.category} className="mb-6">
                <h3 className="px-4 mb-2 text-xs font-semibold text-slate-400 uppercase tracking-wider">
                  {section.category}
                </h3>
                <div>
                  {permittedItems.map(item => (
                    <Link
                      key={item.path}
                      to={item.path}
                      className={`flex items-center px-4 py-2 text-sm ${
                        isActive(item.path)
                          ? 'bg-blue-600 text-white'
                          : 'text-slate-300 hover:bg-slate-700/50 hover:text-slate-100'
                      }`}
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      <span className="mr-3">{item.icon}</span>
                      <span>{item.name}</span>
                    </Link>
                  ))}
                </div>
              </div>
            );
          })}
        </nav>
      </div>
    </>
  );
};

export default APIsSidebar;